import { RouteNames } from '@/shared/config/routes';
import type { NavigationItem } from './types';

export const STATIC_MENU_ITEMS: NavigationItem[] = [
  {
    code: 'DASHBOARD',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    subItems: [
      {
        code: 'DASHBOARD_STORAGE',
        label: 'Storage Overview',
        path: RouteNames.DASHBOARD_STORAGE,
        icon: 'Database',
        helpContentId: null
      },
      {
        code: 'DASHBOARD_TRANSPORT',
        label: 'Transport Overview',
        path: RouteNames.DASHBOARD_TRANSPORT,
        icon: 'Package',
        helpContentId: null
      },
      {
        code: 'DASHBOARD_SERVICE_USERS',
        label: 'Service Users',
        path: RouteNames.DASHBOARD_SERVICE_USERS,
        icon: 'Users',
        helpContentId: null
      },
      {
        code: 'DASHBOARD_MAPPING',
        label: 'Mapping',
        path: RouteNames.DASHBOARD_MAPPING,
        icon: 'Map',
        helpContentId: null
      }
    ]
  }
];

export const DEFAULT_ICON = 'FileText';
